import { Box, Button, Grid, Typography } from '@mui/material'
import { ClassNameMap, withStyles } from '@mui/styles'
import { useEffect, useState } from 'react';
import { environment } from '../../../../environments/environment';
import Helper from '../../../../utils/helper';
import stylesheet from '../detail-container.stylesheet'
import RejectRestrictComponent from './reject-restrict-decision.component';
import moment from 'moment';
import ConfirmationDialogComponent from '../common/confirmation-dialog.component';
import { toast } from 'react-toastify';

interface IProps {
  item: any
  outerSubmit: any
  outer: any
  compKey: string
  value: any
  currentRole: string
  classes: ClassNameMap
}

const ProviderDecisionComponent: React.FC<IProps> = ({
  item,
  outerSubmit,
  outer,
  compKey,
  value,
  currentRole,
  classes,
}) => {
  const [status, setStatus] = useState(item.appr_wrfl_stat);
  const [approveOpen, setApproveOpen] = useState(false)
  const [totalHr, setTotalHr] = useState() as any;

  useEffect(() => {
    if (status === 'Restrict') {
      setStatus(undefined)
      outer(compKey)
    }
  }, [value])

  const approveMed = (_param: any) => {
    setStatus(_param)
    outerSubmit(compKey, _param)
  }
  const handleConfirmClose = () => {
    setApproveOpen(false)
    setTotalHr('')
  }
  const confirmStatus = () => {
    approveMed('Approved')
    handleConfirmClose()
  }

  const onBtnClick = (_param: string) => {
    setApproveOpen(false)
    if (status !== '') approveMed('')
    if (_param === 'Approved') {
      if (item?.recommendation_date === null) {
        toast.warning("Recommendation date is not available. Please reset & generate care plan.", Helper.bottom_center())
        return
      }
      else if (item?.recommendation_date !== null) {
        const timeStp = moment.unix(item.recommendation_date).fromNow();
        console.log('65:recommendation_date timeStp', timeStp)

        let startDate = moment.unix(item.recommendation_date).format('YYYY-MM-DD HH:mm:ss')
        let endDate = moment().format('YYYY-MM-DD HH:mm:ss')

        let diff_milliseconds = Date.parse(endDate) - Date.parse(startDate);
        const seconds = ((diff_milliseconds) / 1000);
        const minutes = (seconds / 60);
        const hours = (minutes / 60);

        console.log('66: recommendation_date', startDate, ' today: ', endDate, ' minutes: ', minutes, ' hours: ', hours)

        if (hours <= 4)
          approveMed(_param)
        else if (hours > 4 && hours <= 24) {
          setTotalHr(Math.floor(hours))
          setApproveOpen(true)
        }
        else
          toast.warning("Recommendation is older than 24 hrs. Please reset & generate care plan.", Helper.bottom_center())
      }
    } else
      approveMed(_param)
  }

  const onBackClick = () => {
    setStatus(undefined)
    outer('med_restriction')
    outer(compKey)
  }

  return (<>
    {Helper.checkGroup(environment.okta.providerGroup, currentRole) &&
      <Grid>
        {status === 'Restrict' &&
          <Box pl={2}>
            <RejectRestrictComponent
              item={item}
              outerSubmit={outerSubmit}
              outer={onBackClick}
              handleClose={{}}
              handleSubmit={{}}
              compKey={compKey}
              parentComp=''
            />
          </Box>
        }
        <Box p={2} className={status === 'Restrict' ? classes.displayNone : classes.subModalBackground} >
          <Grid spacing={1} container>
            <Grid item sm={12}>
              <Typography variant="body2" className={classes.evalBoxVal}>
                {`As the responsible provider, I have updated the medication list and restrictions prior to generating a recommendation, reviewed the rationale, including inclusion/exclusion criteria, reviewed schedules, and considered alternative medication choices. Regarding this recommendation, I :`}              </Typography>
            </Grid>
            <Grid item>
              <Button
                variant="outlined"
                size="small"
                onClick={() => onBtnClick('Approved')}
                className={status === 'Approved' ? classes.dialogBtnActionSelected : classes.dialogBtnAction}
                sx={status === 'Approved' ? {
                  backgroundColor: 'var(--color-btn-selected-bg) !important',
                  color: 'var(--color-btn-selected-text) !important',
                  borderColor: 'var(--color-btn-selected-border) !important',
                } : undefined}
              >
                Approve
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="outlined"
                size="small"
                onClick={() => onBtnClick('Rejected')}
                className={status === 'Rejected' ? classes.dialogBtnActionSelected : classes.dialogBtnAction}
                sx={status === 'Rejected' ? {
                  backgroundColor: 'var(--color-btn-selected-bg) !important',
                  color: 'var(--color-btn-selected-text) !important',
                  borderColor: 'var(--color-btn-selected-border) !important',
                } : undefined}
              >
                Reject
              </Button>
            </Grid>
            {!['med_evaluation', 'early_tox_check'].includes(item.stage) &&
              <Grid item>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={() => onBtnClick('Restrict')}
                  className={classes.dialogBtnAction}
                >
                  {`Reject & restrict`}
                </Button>
              </Grid>
            }
          </Grid>
        </Box>
      </Grid>
    }
    {Helper.checkGroup(environment.okta.navigatorGroup, currentRole) &&
      <Box p={1} className={classes.subModalBackground}>
        <Typography variant='body2' className={classes.evalBoxVal}>Waiting for provider approval</Typography>
      </Box>
    }

    {approveOpen && (
      <ConfirmationDialogComponent
        open={approveOpen}
        content={`Recommendation is ${totalHr} hours old. Are you sure, you want to proceed?`}
        handleConfirmClose={handleConfirmClose}
        confirmStatus={confirmStatus}
      />
    )}
  </>)
}

export default withStyles(stylesheet)(ProviderDecisionComponent)
